<script setup lang="ts">
import { UiIcon, UiText, UiCard } from '@shopexperts/shared';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
    rating: number;
    label?: string;
    mobileLabel?: string;
    size?: 'sm' | 'md' | 'lg';
    ratings?: { label: string; value: number }[];
}>(), {
    size: 'md'
});

const iconSize = computed(() => {
    switch (props.size) {
        case 'sm': return 'w-4 h-4';
        case 'lg': return 'w-5 md:w-6 h-5 md:h-6';
        default: return 'w-4 md:w-5 h-4 md:h-5';
    }
});

const textVariant = computed(() => {
    switch (props.size) {
        case 'sm': return 'p-small';
        case 'lg': return 'h5';
        default: return 'h6';
    }
});
</script>

<template>
    <div class="flex items-center gap-1.5 group/ratingDisplay relative">
        <div class="flex flex-row md:flex-col gap-1 items-end">
            <UiText v-if="label" as="p" :variant="textVariant" class="hidden md:block" :text="props.label" />
            <UiText v-if="label" as="h6" :variant="textVariant" class="block md:hidden" :text="props.mobileLabel ?? props.label" />
            <div class="flex items-center gap-1">
                <UiIcon name="dynamic-star" :class="[iconSize, 'text-se-green']" />
                <UiText as="p" :variant="textVariant" class="font-semibold block" :text="rating.toFixed(1)" no-wrap />
            </div>
        </div>
        <UiCard padding="sm" class="flex-shrink-0 group-hover/ratingDisplay:flex hidden absolute top-6 -right-2">
            <div class="flex flex-col gap-2">
                <div class="flex justify-between items-center gap-2" v-for="rating in ratings" :key="rating.label">
                    <UiText as="span" variant="p-small" class="text-gray-600" :text="rating.label" no-wrap />
                    <div class="flex items-center gap-1">
                        <UiIcon name="dynamic-star" class="w-4 h-4 text-se-green" />
                        <UiText as="span" variant="p-small" class="font-semibold" :text="rating.value.toFixed(1)" />
                    </div>
                </div>
            </div>
        </UiCard>
    </div>
</template>
